export default __webpack_public_path__ + "static/media/No.2-1.1b162c90.jpg";